import { useEffect } from 'react';
import { Box } from '@nimbus-ds/components';
import { CheckoutPaymentMethod } from '@tiendanube/common/src/enums';
import { useDesktopMenuContext } from 'App/components/Menu/DesktopMenuProvider';
import useTopBar from 'App/components/Topbar/useTopBar';
import { useNavegate } from 'App/hooks';
import {
  HeaderContent,
  HeaderTop,
  IonPageStratus,
  Layout,
} from 'commons/components';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { CreditCardDataCard, IncludeTransactionFee } from './components';
import { useIncludeTransactionFees } from './hooks';
import { usePayorderToPay } from '../../hooks';
import { trackingBillingViewPayCreditCard } from '../../tracking';
import { PayOrderSummary } from '../components';

function PayWithCreditCard() {
  const t = useTranslationBilling('checkout.payWithCreditCard');
  const tBilling = useTranslationBilling();
  const { goBack } = useNavegate();
  const { isShowMenu } = useTopBar();
  const { isShowMenu: isShowAsideMenu } = useDesktopMenuContext();
  const backNavigation = {
    onClick: goBack,
    children:
      !isShowMenu && !isShowAsideMenu
        ? tBilling('billingPlansPage.back')
        : undefined,
  };

  const { recurrentPaymentCompatible, mainConcept } = usePayorderToPay();

  useEffect(() => {
    trackingBillingViewPayCreditCard(mainConcept);
  }, [mainConcept]);

  const { includeTransactionFee, setIncludeTransactionFee } =
    useIncludeTransactionFees();

  return (
    <IonPageStratus
      headerTop={<HeaderTop navigation={backNavigation} />}
      headerContent={
        <HeaderContent
          title={t(recurrentPaymentCompatible ? 'titleWithRp' : 'title')}
        />
      }
      width="large"
    >
      <Layout
        left={
          <CreditCardDataCard includeTransactionFee={includeTransactionFee} />
        }
        right={
          <Box display="flex" flexDirection="column" gap="3">
            <IncludeTransactionFee
              includeTransactionFee={includeTransactionFee}
              onCheckIncludeTransactionFee={setIncludeTransactionFee}
            />
            <PayOrderSummary
              showTaxes
              showPeriodDiscounts
              paymentMethod={CheckoutPaymentMethod.CC}
            />
          </Box>
        }
        mainContent
        orderMobile="reverse"
      />
    </IonPageStratus>
  );
}

export default PayWithCreditCard;
